import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AppointmentIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Appointment",
    children: isCanvas ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M26.12 16.69c-2.98 0-4.41 3.26-4.41 3.26s-1.42-3.26-4.41-3.26-4 2.92-4 4.41c0 2.98 2.85 7.12 8.41 9.9 5.56-2.78 8.41-6.92 8.41-9.9 0-1.5-1.02-4.41-4.01-4.41Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M11.37 23.22H5c-.36 0-.65-.29-.65-.65V7.34c0-.31.25-.56.56-.56h1.65v1.84c0 .68.55 1.24 1.24 1.24s1.24-.55 1.24-1.24V6.78h7.94v1.84c0 .68.55 1.24 1.24 1.24s1.24-.55 1.24-1.24V6.78h1.56c.36 0 .65.29.65.65v7.2c0 .32.26.57.57.57h1.33c.32 0 .57-.26.57-.57V6.49c0-1.2-.98-2.18-2.18-2.18h-2.51V2.23c0-.68-.55-1.24-1.24-1.24s-1.24.55-1.24 1.24v2.08H9.03V2.23c0-.68-.55-1.24-1.24-1.24s-1.24.55-1.24 1.24v2.08h-2.5c-1.21 0-2.19.98-2.19 2.18V23.5c0 1.21.98 2.19 2.19 2.19h7.31c.25 0 .45-.2.45-.45v-1.57c0-.25-.2-.45-.45-.45Z"
      }), /*#__PURE__*/_jsx("rect", {
        width: "3.54",
        height: "3.54",
        x: "6.13",
        y: "11.67",
        rx: ".9",
        ry: ".9"
      }), /*#__PURE__*/_jsx("rect", {
        width: "3.54",
        height: "3.54",
        x: "6.13",
        y: "16.33",
        rx: ".9",
        ry: ".9"
      }), /*#__PURE__*/_jsx("rect", {
        width: "3.54",
        height: "3.54",
        x: "11.18",
        y: "11.67",
        rx: ".9",
        ry: ".9"
      }), /*#__PURE__*/_jsx("rect", {
        width: "3.54",
        height: "3.54",
        x: "16.23",
        y: "11.67",
        rx: ".9",
        ry: ".9"
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M25.86 29.29h-8a1.14 1.14 0 1 1 0-2.28h8c.63 0 1.14-.51 1.14-1.14V7.57c0-.63-.51-1.14-1.14-1.14H5.29c-.63 0-1.14.51-1.14 1.14V11h19.43a1.14 1.14 0 1 1 0 2.28H3c-.63 0-1.14-.51-1.14-1.14V7.57c0-1.89 1.54-3.43 3.43-3.43h20.57c1.89 0 3.43 1.54 3.43 3.43v18.29c0 1.89-1.54 3.43-3.43 3.43"
      }), /*#__PURE__*/_jsx("path", {
        d: "M9.86 8.71c-.63 0-1.14-.51-1.14-1.14V3A1.14 1.14 0 1 1 11 3v4.57c0 .63-.51 1.14-1.14 1.14M21.29 8.71c-.63 0-1.14-.51-1.14-1.14V3a1.14 1.14 0 1 1 2.28 0v4.57c0 .63-.51 1.14-1.14 1.14M9.46 29.29c-.28 0-.57-.11-.79-.32l-5.56-5.3c-.8-.76-1.25-1.83-1.25-2.92 0-2.23 1.81-4.04 4.04-4.04h.37c1.08 0 2.09.42 2.86 1.18l.34.34.34-.34c.75-.75 1.79-1.18 2.86-1.18h.37c2.23 0 4.04 1.81 4.04 4.04 0 1.1-.46 2.17-1.25 2.92l-5.56 5.3c-.22.21-.5.32-.79.32Zm-4.77-7.28 4.78 4.55 4.78-4.55c.35-.33.54-.79.54-1.27 0-.97-.79-1.75-1.75-1.75h-.37c-.46 0-.91.19-1.24.51l-1.15 1.15c-.43.43-1.19.43-1.62 0L7.51 19.5c-.33-.33-.77-.51-1.24-.51H5.9a1.752 1.752 0 0 0-1.21 3.02"
      })]
    })
  }));
};
AppointmentIcon.displayName = 'AppointmentIcon';